export default __webpack_public_path__ + "static/media/profile_pic.b8797803.jpg";